import {
  Grid,
  Paper,
  TableContainer,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import Loader from "../../../Components/Loader";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { updateUserAPI } from "../../../Store/Action/UserAction";
import Colors from "../../../theme/Colors";

const UpdateManufactures = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { manufacture } = location?.state || {};

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (manufacture && manufacture.user_first_name) {
      setBreadcrumbs([
        { key: "1", href: "/", text: "Home" },
        { key: "2", href: "/manufacturesList", text: "Manufacturer" },
        {
          key: "3",
          href: "/manufacturesList/edit",
          text: `Update ${manufacture.user_first_name}`,
        },
      ]);
    }
  }, [manufacture]);

  if (!manufacture) {
    return <div>No User details available.</div>;
  }

  const onSubmit = async (data) => {
    const updateUserData = {
      user_first_name: data?.firstName,
      user_last_name: data?.lastName,
      user_email: data?.userAddress,
      user_address: data?.userEmail,
    };
    setLoading(true);
    try {
      await dispatch(
        updateUserAPI(updateUserData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success(
              response?.data?.message || "User Updated Successfully"
            );
            navigate("/userList");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Manufacturer</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>
            Update {manufacture.user_first_name} Details
          </p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>First Name</Typography>
                <Controller
                  name="firstName"
                  control={control}
                  defaultValue={manufacture.user_first_name}
                  rules={{ required: Strings.firstNameRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="First Name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.firstName}
                      helperText={
                        errors?.firstName ? errors?.firstName.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Last Name</Typography>
                <Controller
                  name="lastName"
                  control={control}
                  defaultValue={manufacture.user_last_name}
                  rules={{ required: Strings.lastNameRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Last Name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.lastName}
                      helperText={
                        errors?.lastName ? errors?.lastName.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>User Address</Typography>
                <Controller
                  name="userAddress"
                  control={control}
                  defaultValue={manufacture.user_address}
                  rules={{ required: Strings.userAddressRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="User Address"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.userAddress}
                      helperText={
                        errors?.userAddress ? errors?.userAddress.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>User Email</Typography>
                <Controller
                  name="userEmail"
                  control={control}
                  defaultValue={manufacture.user_email}
                  rules={{ required: Strings.userEmailRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="User Email"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.userEmail}
                      helperText={
                        errors?.userEmail ? errors?.userEmail.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "20px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

export default UpdateManufactures;
